import React, { useEffect, useState } from "react";
import { Modal, Table, Button, Popconfirm, Select, message, Input } from "antd";
import axios from "axios";
import { Base_Uri } from "../Constant/BaseUri";

const ProductTableModal = ({ visible, onClose, products }) => {
  const [selectedPO, setSelectedPO] = useState({});
  const [loading, setLoading] = useState(false);

  // Example Purchase Orders (you can fetch from API)
  const [purchaseOrders,setPurchaseOrders] = useState([]);

  useEffect(()=>{
let data =  sessionStorage.getItem("userData");
      data = JSON.parse(data);
      let token = data;
      axios.get(`${Base_Uri}getAllPurchaseOrders?status=pending`, {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json", 
            },
          }).then((item)=>{
//console.log(item.data.data)
setPurchaseOrders(item.data.data?.map((e)=>({label:"PO "+e?.purchaseOrder_number,value:e?._id})))
          })
  },[])

  const handleAddToPO = async (record) => {
    let data =  sessionStorage.getItem("userData");
      data = JSON.parse(data);
      let token = data;
    const poId = record?.poId;
    if (!poId) {
      message.warning("Please select a Purchase Order first");
      return;
    }
    if (!record?.addingQty) {
      message.warning("Please add qty first");
      return;
    }

    setLoading(true);
    //console.log(record)
    try {
      // Example API call
      const res = await axios.post(`${Base_Uri}updatePurchasedOrderWithReport`, {
        productId: record._id,
        poId: poId,
        orderQty: Number(record?.addingQty),
      }, {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json", 
            },
          });

      if (res.data.success) {
        message.success(`${record.productName} added to PO-${poId}`);
      } else {
        message.error(res.data.message || "Failed to add product");
      }
    } catch (error) {
      message.error(error?.response?.data?.message || "Server error");
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      title: "Product Name",
      dataIndex: "productName",
      key: "productName",
    },
    {
      title: "Cost Price",
      dataIndex: "cost_price",
      key: "cost_price",
      render: (_, record) => ((record?.cost_price).toFixed(2))
    },
    {
      title: "Sale Qty",
      dataIndex: "qty",
      key: "qty",
    },
    {
      title: "Total Amount",
      dataIndex: "totalAmount",
      key: "totalAmount",
       render: (_, record) => ((record?.totalAmount).toFixed(2))
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <div style={{ display: "flex", gap: 8 }}>
          <Select
            placeholder="Select PO"
            style={{ width: 150 }}
            options={purchaseOrders}
            value={record?.poId}
            onChange={(val) => record.poId = val}
          />
          <Input
            placeholder="Adding Qty"
            style={{ width: 150 }}
            value={record?.addingQty}
            onChange={(val) => record.addingQty = val.target.value}
          />
          <Popconfirm
            title="Add this product to selected Purchase Order?"
            onConfirm={() => {
                handleAddToPO(record)
            //    delete record.poId 
            //    delete record.addingQty
            }}
            okText="Yes"
            cancelText="No"
          >
            <Button type="primary" loading={loading}>
              Add
            </Button>
          </Popconfirm>
        </div>
      ),
    },
  ];

  return (
    <Modal
      open={visible}
      onCancel={onClose}
      width={1100}
      footer={null}
      title="Products"
    >
      <Table
        rowKey="_id"
        columns={columns}
        dataSource={products}
        pagination={false}
      />
    </Modal>
  );
};

export default ProductTableModal;
